/**
 * @file Actions for Padlet Mini 5 release tour
 * @see https://app.commandbar.com/editor/product-tours/15546
 */
import device from '@@/bits/device'

const STORE_URLS = {
  chrome: 'https://chromewebstore.google.com/detail/padlet-mini/kcljbbiddpoeaknnjaminoceoojdbikp',
  edge: 'https://microsoftedge.microsoft.com/addons/detail/padlet-mini/chdcjmemggihkfoncbakagfcpmbgdnda',
  firefox: 'https://addons.mozilla.org/en-US/firefox/addon/padlet-mini/',
  safari: 'https://apps.apple.com/us/app/padlet-mini/id1562602273',
}

const padletMiniStoreURL = (): string => {
  // if browser does not match any of the below, default to chrome
  let storeURL = STORE_URLS.chrome
  if (device.edge) {
    storeURL = STORE_URLS.edge
  } else if (device.firefox) {
    storeURL = STORE_URLS.firefox
  } else if (device.safari) {
    storeURL = STORE_URLS.safari
  }
  return storeURL
}

/**
 * @see https://app.commandbar.com/editor/actions/881443
 */
function navigateToPadletMiniStoreURL(): void {
  window.open(padletMiniStoreURL(), '_blank')
}

export { navigateToPadletMiniStoreURL, padletMiniStoreURL }
